import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { fluidType, device } from '../../../utils/helpers'
import Submenu from './Submenu'

const Wrapper = styled.ul`
  display: none;
  list-style: none;
  ${fluidType('480px', '1920px', '16px', '24px')};


  @media ${device.tablet} {
    height: 100%;
    display: flex;
    align-items: center;
    font-family: 'BarlowSemiBold';
    color: #fff;
    text-transform: uppercase;
    width: 68.359375vw;
    justify-content: flex-start;
    gap: 40px;
    padding-left: 2.604166666666667vw;
  }

  @media ${device.laptop} {
    width: 900px;
  }
`

const ListItem = styled.li`
  @media ${device.tablet} {
    height: 100%;
    display: flex;
    align-items: center;

    &:hover > div {
      display: block;
    }
  }
`

const StyledLink = styled.a`
  text-decoration: none;
  color: #fff;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.color.hoverPrimary};
  }
`

// Menu Item
const Item = ({ children, href, submenu, name, ...props }) => (
  <ListItem {...props}>
    <StyledLink href={href}>{children}</StyledLink>
    {submenu && <Submenu name={name} items={submenu} />}
  </ListItem>
)

const Navbar = ({ items }) => (
  <Wrapper>
    {items.map(item => {
      if (item.submenu) {
        return (
          <Item key={item.name} href={item.url}
            // submenu={item.submenu}
          name={item.name}>{item.name}</Item>
        )
      } else {
        return (
          <Item key={item.name} href={item.url}>{item.name}</Item>
        )
      }
    })}
  </Wrapper>
)

export default Navbar



// WEBPACK FOOTER //
// ./src/components/UI/Header/Navbar.js